import React, { useState, useEffect } from 'react';
import { fetchInstances, startInstance, stopInstance } from './api';

interface Instance {
  id: string;
  name?: string;
  state: string;
  type?: string;
  ip?: string;
}

export function Dashboard() {
  const [items, setItems] = useState<Instance[]>([]);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    loadInstances();
  }, []);

  async function loadInstances() {
    try {
      setLoading(true);
      setError('');
      const instances = await fetchInstances();
      setItems(Array.isArray(instances) ? instances : []);
    } catch (e) {
      setError(String(e));
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

  async function act(id: string, op: 'start' | 'stop') {
    try {
      setError('');
      if (op === 'start') {
        await startInstance(id);
      } else {
        await stopInstance(id);
      }
    } catch (e) {
      setError(`${op} failed: ${String(e)}`);
    }
    await loadInstances();
  }

  if (loading) {
    return <div>Loading instances...</div>;
  }

  return (
    <div>
      <h2>Dashboard</h2>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {items.length === 0 ? (
        <p>No instances available</p>
      ) : (
        <ul>
          {items.map((it) => (
            <li key={it.id}>
              <div>
                <strong>{it.name ?? it.id}</strong> - {it.state}
                {it.type && <span> ({it.type})</span>}
                {it.ip && <span> IP: {it.ip}</span>}
              </div>
              <button
                disabled={it.state === 'running'}
                onClick={() => act(it.id, 'start')}
              >
                Start
              </button>
              <button
                disabled={it.state !== 'running'}
                onClick={() => act(it.id, 'stop')}
              >
                Stop
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
